import { render, staticRenderFns } from "./NovoFormularioPage.vue?vue&type=template&id=48fe44cd&scoped=true"
import script from "./NovoFormularioPage.vue?vue&type=script&lang=js"
export * from "./NovoFormularioPage.vue?vue&type=script&lang=js"
import style0 from "./NovoFormularioPage.vue?vue&type=style&index=0&id=48fe44cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe44cd",
  null
  
)

export default component.exports